import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../../core/models/auth';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAuth = createSelector(
  selectAuthState,
  (state: AuthState) => state.authResponse
);


export const selectGeneralAuth = createSelector(
  selectAuthState,
  (state: AuthState) => state
);

export const selectAuthFirebase = createSelector(
  selectAuthState,
  (state: AuthState) => state.firebaseResponse
);
